module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "song-search"
  }, [_c('b-field', {
    staticClass: "song-search",
    attrs: {
      "label": "Find a song"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.showTags) ? _c('div', {
    staticClass: "input-group-element minor"
  }, [_c('b-taginput', {
    attrs: {
      "data": _vm.availableTags,
      "ellipsis": "",
      "autocomplete": "",
      "field": "name",
      "icon": "label",
      "placeholder": "Add a tag"
    },
    on: {
      "typing": _vm.getFilteredTags,
      "input": _vm.getAsyncSongs
    },
    model: {
      value: (_vm.selectedTags),
      callback: function($$v) {
        _vm.selectedTags = $$v
      },
      expression: "selectedTags"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group-element",
    class: _vm.showTags ? 'major' : 'alone'
  }, [_c('b-autocomplete', {
    attrs: {
      "rounded": "",
      "data": _vm.filteredSongs,
      "placeholder": "e.g. Alleluia",
      "field": "title",
      "icon": "magnify",
      "loading": _vm.isFetchingSongs,
      "open-on-focus": true
    },
    on: {
      "typing": _vm.getAsyncSongs,
      "select": function($event) {
        return _vm.$emit('selectSong', $event)
      }
    }
  }, [_c('template', {
    slot: "empty"
  }, [_vm._v("\n            No results found\n          ")])], 2)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1283761f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchSong.vue
// module id = 312
// module chunks = 2